import * as actionTypes from '../actionTypes';

const modalInit = {
  text: '',
};
const showErrorInit = { message: '', type: 'error' };

const modal = (state = modalInit, action) => {
  switch (action.type) {
    case actionTypes.MODAL:
      return action.modal;

    case actionTypes.CLEAR_MODAL:
      return action.modal;

    default:
      return state;
  }
};

const showError = (state = showErrorInit, action) => {
  switch (action.type) {
    case actionTypes.SHOW_ERROR:
      if (state.timer) {
        clearTimeout(state.timer);
      }
      return { ...action.showError, timer: action.timer };

    case actionTypes.CLEAR_ERROR:
      return showErrorInit;
    default:
      return state;
  }
};

const isLoading = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_LOADING:
      return action.isLoading;
    default:
      return state;
  }
};

const reducer = { modal, isLoading, showError };
export default reducer;
